var commonBreakpoints = ['375px', '768px', '1024px', '1200px']; // aliases

commonBreakpoints.mobile = commonBreakpoints[0];
commonBreakpoints.tablet = commonBreakpoints[1];
commonBreakpoints.laptop = commonBreakpoints[2];
commonBreakpoints.desktop = commonBreakpoints[3];

export { commonBreakpoints };
